import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import vensoRepository from "@/services/VensoRepository";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
export default class SaveVensoDeliveryReceipt extends AbstractCommand {
    orderId;
    update;
    constructor(orderId, update) {
        super();
        this.orderId = orderId;
        this.update = update;
    }
    async execute() {
        try {
            const dto = await vensoRepository.saveDeliveryReceipt(this.orderId, this.update);
            alerts.success(trans('venso_delivery_receipt.save_success'));
            return dto;
        }
        catch (e) {
            alerts.error(trans(`${this.name()}.error`));
            throw e;
        }
    }
    name() {
        return 'save_venso_delivery_receipt';
    }
    icon() {
        return 'check';
    }
}
